import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { SectionTitle } from "../ui/SectionTitle";
import { lifestyle } from "../../data/images";
import { FUTURE_PRICE } from "../../data/offer";
export function TwoPathsSection() {
  return <section className="bg-blush-light py-20 lg:py-28" data-id="element-508" data-mp="2uykaw7mjvvv7">
      <div className="mx-auto max-w-6xl px-5" data-id="element-509" data-mp="2uwzgqj45eexv">
        <SectionTitle intro="Te voy a ser honesta. En este momento tienes dos caminos:" data-id="element-510" data-mp="38xk0pilsugsy">Tu Decisión de Hoy Cambia Mañana</SectionTitle>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-511" data-mp="34voy8as4txdl">
          <Reveal className="h-full" data-id="element-512" data-mp="3inlmu4uldp58">
            <article className="flex h-full flex-col overflow-hidden rounded-3xl bg-white/70 ring-1 ring-cocoa/10" data-id="element-513" data-mp="3imk4rgf5s2e0">
              <img src={lifestyle.kitchen} alt="" className="aspect-[16/9] w-full object-cover grayscale" loading="lazy" data-id="element-514" data-mp="3dpk5boctdxvv" />
              <div className="flex flex-1 flex-col p-7" data-id="element-515" data-mp="3nmybmv50x6ag">
                <p className="flex items-center gap-2 text-sm font-bold text-cocoa-light" data-id="element-516" data-mp="3no9hr1lxyq4q">
                  <XIcon className="h-4 w-4" data-id="element-517" data-mp="2s67ckpmm2wzb" /> Camino 1
                </p>
                <h3 className="mt-1 font-display text-2xl font-bold text-cocoa-light" data-id="element-518" data-mp="2x3h205a038n5">Sigues como estás.</h3>
                <p className="mt-3 leading-relaxed text-cocoa-light" data-id="element-519" data-mp="315au3p64r4bp">
                  Intentando recetas de YouTube. Gastando dinero en ingredientes que no funcionan. Viviendo ese ciclo de restricción y culpa.
                  Viéndote al espejo y pensando "mañana es el día que cambio".
                </p>
              </div>
            </article>
          </Reveal>

          <Reveal delay={0.08} className="h-full" data-id="element-520" data-mp="3ktjrqeqg02il">
            <article className="flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-[0_30px_60px_-25px_rgba(199,37,78,0.45)] ring-2 ring-berry" data-id="element-521" data-mp="3ku383r0g2iui">
              <img src={lifestyle.kids} alt="" className="aspect-[16/9] w-full object-cover" loading="lazy" data-id="element-522" data-mp="3turlcji0kf6c" />
              <div className="flex flex-1 flex-col p-7" data-id="element-523" data-mp="2n5d0dkcnoj5">
                <p className="flex items-center gap-2 text-sm font-bold text-berry" data-id="element-524" data-mp="2llu0f7b6zdo">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-525" data-mp="1yrcvc14s8793" /> Camino 2
                </p>
                <h3 className="mt-1 font-display text-2xl font-bold text-cocoa" data-id="element-526" data-mp="1tttcsp11x8bc">Das el paso hoy.</h3>
                <p className="mt-3 leading-relaxed text-cocoa-light" data-id="element-527" data-mp="28i7g112dqysf">
                  Llevas el Pack Dulce Saludable, pruebas una receta esta semana, ves cómo cambia todo, y descubres que finalmente puedes disfrutar
                  de postres <b className="text-cocoa" data-id="element-528" data-mp="2dfzeyf1fzl64">SIN sacrificar tu salud, tu digestión o tu paz mental.</b>
                </p>
              </div>
            </article>
          </Reveal>
        </div>

        <div className="mx-auto mt-16 grid max-w-5xl items-center gap-10 md:grid-cols-[auto_1fr]" data-id="element-529" data-mp="2mgnw3im4u1n8">
          <Reveal className="mx-auto text-center" data-id="element-530" data-mp="x1ptptshycji">
            <p className="font-display text-7xl font-bold leading-none text-berry" data-id="element-531" data-mp="x2isa7haxvqk">90</p>
            <p className="text-sm font-bold uppercase tracking-widest text-cocoa" data-id="element-532" data-mp="s3oa97r5sb7i">minutos esta semana</p>
          </Reveal>
          <Reveal delay={0.05} className="space-y-4 text-lg leading-relaxed text-cocoa-light" data-id="element-533" data-mp="33qrtolrg3a0d">
            <p data-id="element-534" data-mp="38ojmdhzwz05m">
              La diferencia entre estos dos caminos no es dinero. Es 90 minutos de tu tiempo esta semana. Es probar algo diferente. Es darle a tu
              cuerpo (y a tu mente) la oportunidad que se merece.
            </p>
            <p data-id="element-535" data-mp="2kzrz9516l7zp">
              Y aquí está lo mejor: <b className="text-cocoa" data-id="element-536" data-mp="2kyp9j0flhbld">hoy es el día en que el precio es más bajo que nunca.</b> Después de que este
              contador llegue a cero, subirá a ${FUTURE_PRICE}. No porque sea más valioso entonces (el contenido será exactamente el mismo), sino
              porque queremos que las personas realmente comprometidas con su salud — como tú — tengan acceso a precio especial.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}